export const getUserAccessLevels = user => {
    if (!user) return null
    return { groups: user.user_groups.map(n => Number(n.id)), isAdmin: user.id === 1 && user.username === 'admin' }
}
